import {remote} from '../constants/environment';
import {defaultHeaders} from './headers';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {IStatusFilter} from '../context/commons/interfaces';
import {IOrderListResponse} from '../interfaces/services/order-list-response.interface';

export const getSalesmanOrderList = async (
  token: string,
  filter?: IStatusFilter | null,
): Promise<IOrderListResponse> => {
  const remoteURI = remote.getSalesmanOrdersListUri();

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'POST',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
        body: JSON.stringify({
          payload: filter ?? null,
        }),
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const data = await response.json();
        if (data.success && data.payload) {
          const success = true;
          const {payload} = data;
          return {
            success,
            payload,
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as IOrderListResponse;
};
